import { SITE } from "../data/site";
import Seo from "../Components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Datenschutz"
        description="Datenschutzerklärung von CCS Gebäudemanagement."
        path="/datenschutz"
      />
      <section className="section">
        <div className="wrap legal">
          <p className="kicker">Rechtliches</p>
          <h1 className="display">Datenschutz</h1>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist{" "}
            {SITE.name}, {SITE.owner}, {SITE.addresses[0].street},{" "}
            {SITE.addresses[0].zip} {SITE.addresses[0].city}, E-Mail: {SITE.email},
            Telefon: {SITE.phoneDisplay}.
          </p>
          <h2>Hosting</h2>
          <p>
            Die Website wird über GitHub Pages bereitgestellt. Beim Aufruf werden
            technisch notwendige Server-Logdaten (z. B. IP-Adresse, Zeitpunkt,
            aufgerufene Datei) durch den Hosting-Anbieter verarbeitet. Rechtsgrundlage
            ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren
            Betrieb der Website).
          </p>
          <h2>Kontaktaufnahme</h2>
          <p>
            Wenn Sie uns per Formular, E-Mail oder Telefon kontaktieren, verarbeiten
            wir die von Ihnen mitgeteilten Daten ausschließlich zur Bearbeitung der
            Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche
            Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p>
            Das Kontaktformular wird über den E-Mail-Dienst Resend (Resend, Inc.)
            an {SITE.email} zugestellt. Dabei werden Name, Telefonnummer,
            E-Mail-Adresse, gewünschte Leistung und Nachricht an Resend
            übermittelt, um die Nachricht zuzustellen. Rechtsgrundlage ist Art. 6
            Abs. 1 lit. b DSGVO. Hinweise des Anbieters:{" "}
            <a href="https://resend.com/legal/privacy-policy" rel="noopener noreferrer">
              resend.com
            </a>
            .
          </p>
          <h2>Google Maps</h2>
          <p>
            Auf der Kontaktseite ist eine Karte von Google Maps eingebettet. Beim
            Laden der Karte kann Google (Google Ireland Limited) personenbezogene
            Daten verarbeiten, einschließlich der IP-Adresse. Die Einbindung erfolgt
            im Interesse einer leichten Auffindbarkeit unseres Standorts (Art. 6 Abs.
            1 lit. f DSGVO).
          </p>
          <h2>Cookies</h2>
          <p>
            Diese Website setzt keine Tracking-Cookies. Es werden keine Profile zu
            Werbezwecken gebildet.
          </p>
          <h2>Ihre Rechte</h2>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung
            der Verarbeitung, Datenübertragbarkeit und Widerspruch sowie das Recht,
            eine Beschwerde bei einer Aufsichtsbehörde einzulegen. Eine erteilte
            Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.
          </p>
          <p>
            Zuständige Aufsichtsbehörde in NRW: Landesbeauftragte für Datenschutz und
            Informationsfreiheit Nordrhein-Westfalen.
          </p>
        </div>
      </section>
    </>
  );
}
